import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { AuthService } from '@auth/services/auth.service';

/**
 * A API não expõe endpoint de refresh token (confirmado no Swagger), por isso
 * não há retentativa em 401 aqui — o errorInterceptor trata a sessão expirada.
 *
 * Só /Auth/login e /Auth/loginFirst são públicos (sem sessão ainda). Outros
 * endpoints de /Auth/* (ex.: ResetarSenha) são ações autenticadas e devem
 * levar o Bearer token como qualquer outro pedido.
 */
const PUBLIC_AUTH_PATHS = ['/Auth/login', '/Auth/loginFirst'];

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const auth = inject(AuthService);

  if (PUBLIC_AUTH_PATHS.some((path) => req.url.includes(path))) {
    return next(req);
  }

  const token = auth.getAccessToken();
  const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authReq);
};
